module.exports = {"210203001":"香炉礁街道","210203002":"站北街道","210203004":"日新街道","210203005":"北京街道","210203010":"八一路街道","210203011":"人民广场街道","210203013":"白云街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210203.json
// module id = 467
// module chunks = 0